import { ThirdPartyFormConfirmation } from '@repo/ui/ThirdPartyFormConfirmation'
import { ThirdPartyFormReviewData } from '@repo/ui/ThirdPartyFormReviewData'
import { ThirdPartyFormSelectForm } from '@repo/third-party-forms-table/ThirdPartyFormSelectForm'
import { ThirdPartyFormSelectOptions } from '@repo/ui/ThirdPartyFormSelectOptions'
import { useThirdPartyFormWizardStore } from '@repo/store/useThirdPartyFormWizardStore'

export default [
  {
    stageLabel: 'Add a third-party form',
    stageId: 'add-form',
    resetData: useThirdPartyFormWizardStore.getState().reset,
    steps: [
      {
        stepLabel: 'Select options',
        stepDescription: 'Get started by confirming where the form belongs, and where it will come from',
        stepId: 'select-options',
        skippable: false,
        component: ThirdPartyFormSelectOptions,
        uniqueId: 'third-party-form-select-options'
      },
      {
        stepLabel: 'Select form',
        stepDescription: 'Choose the form you want to create',
        stepId: 'select-form',
        skippable: false,
        component: ThirdPartyFormSelectForm,
        uniqueId: 'third-party-form-select-form'
      },
      {
        stepLabel: 'Review data',
        stepDescription: 'Review the data that will populate the form',
        stepId: 'review-data',
        skippable: false,
        component: ThirdPartyFormReviewData,
        uniqueId: 'third-party-form-review-data'
      },
      {
        stepLabel: 'Confirmation',
        stepDescription: 'Confirm and create the form',
        stepId: 'confirmation',
        skippable: false,
        component: ThirdPartyFormConfirmation,
        uniqueId: 'third-party-form-confirmation'
      }
    ]
  }
]
